/** Environment site ids currently assigned to the document (any environment). */
export function getAssignedEnvironmentSiteIds(assignments, consentDocumentId) {
    return assignments.filter((a) => a.consentDocumentId === consentDocumentId).map((a) => a.environmentSiteId);
}
/** Consent document ids currently assigned to the environment site (any document). */
export function getAssignedConsentDocumentIds(assignments, environmentSiteId) {
    return assignments.filter((a) => a.environmentSiteId === environmentSiteId).map((a) => a.consentDocumentId);
}
